// extracted by mini-css-extract-plugin
export default {"caixaBtn":"BtnSairConta_caixaBtn__xRO41","logoutBtn":"BtnSairConta_logoutBtn__IaUWM"};